import React, { useEffect, useState } from 'react';
import FeatureBox from '@componentsV2/FeatureBox';
import { useSanityContent } from '@hooksV2/useSanityContent';

import NewsletterSignup from '@componentsV2/NewsletterSignup';
import useDashboardLinkPrefix from '../../hooks/useDashboardLinkPrefix';
import {
  getLoyaltyCompanyCode,
  getLoyaltyCompanyLogo,
  getLoyaltyCompanyName,
  getLoyaltyCompanyShortDescription,
} from '../../utils/LoyaltyCompanies';
import { getImageKitImageUrlForSanity } from '../../content/contentHelpers';
import { StyledLoyalty } from './styles';

const NoBMLoyalty = () => {
  const [vendorsPageData, setVendorsPageData] = useState(null);
  const dashboardLinkPrefix = useDashboardLinkPrefix();
  const sanityData = useSanityContent();
  useEffect(() => {
    setVendorsPageData(sanityData.vendorsPageContent[0]);
  }, []);
  return (
    <StyledLoyalty>
      <h2>{vendorsPageData?.headline}</h2>
      <p>
        {vendorsPageData?.paragraph1}
        <br />
        <br />
        {vendorsPageData?.paragraph2}
      </p>
      <div className="company_advantages">
        {sanityData.LoyaltyCompanies?.map((company) => (
          <FeatureBox
            key={getLoyaltyCompanyCode(company)}
            headline={getLoyaltyCompanyName(company)}
            logo={getImageKitImageUrlForSanity(getLoyaltyCompanyLogo(company))}
            boxClassName="company_box"
            linkText="Se tilbudet →"
            to={
              getLoyaltyCompanyCode(company) === 'sparebank-1-sorost-norge' &&
              !`${dashboardLinkPrefix}`.includes('personal-area')
                ? `${dashboardLinkPrefix}/vendors/company/sparebank-1-sorost-norge`
                : `vendors/company/${getLoyaltyCompanyCode(company)}`
            }
          >
            {getLoyaltyCompanyShortDescription(company)}
          </FeatureBox>
        ))}
      </div>
      <NewsletterSignup />
    </StyledLoyalty>
  );
};

export default NoBMLoyalty;
